<template>
  <div class="MessageList">
    <div class="item" @click="goDetail">
      <div class="title">标题名称A</div>
      <div class="value">文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容</div>
      <div class="date">
        <span>平台通知</span>
        <span>2019-01-21 15:40</span>
      </div>
    </div>
    <div class="item" @click="goDetail">
      <div class="title">标题名称B</div>
      <div class="value">文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容</div>
      <div class="date">
        <span>平台通知</span>
        <span>2019-01-21 15:40</span>
      </div>
    </div>
    <div class="item" @click="goDetail">
      <div class="title">标题名称C</div>
      <div class="value">文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容</div>
      <div class="date">
        <span>平台通知</span>
        <span>2019-01-21 15:40</span>
      </div>
    </div>
    <div class="item" @click="goDetail">
      <div class="title">标题名称D</div>
      <div class="value">文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容</div>
      <div class="date">
        <span>平台通知</span>
        <span>2019-01-21 15:40</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MessageList",
    data: function () {
      return {

      };
    },
    components: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
      goDetail(){
        this.$router.replace({ path: `/messageDetails?id=1` });
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
.MessageList{
  padding: 0 20px;
  box-sizing: border-box;
  .item{
    padding:20px;
    box-sizing: border-box;
    margin-top: 20px;
    height: 240px;
    background: #fff;
    .title{
      font-size: 34px;
    }
    .value{
      margin-top: 20px;
      font-size: 26px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .date{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      box-sizing: border-box;
      margin-top: 20px;
      border-top: 2px dashed #9f9f9f;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/message/MessageList.vue